import { ActionTree } from 'vuex'

import api from '@/apiClient'

import { Credentials } from '@/models'

import { RootState } from '../state'
import { UPDATE_TOKEN, UPDATE_TOKEN_V2 } from './mutations'
import { AuthState } from './state'
import { STORAGE_KEY_TOKEN, STORAGE_KEY_TOKEN_V2 } from './types'

const actions: ActionTree<AuthState, RootState> = {
  /**
   * Authenticates with the API and fetches all Tokens.
   *
   * It stores the Tokens in the localStorage.
   *
   * @param credentials User email and password.
   */
  async login ({ commit }, credentials: Credentials) {
    const token = await api.auth.fetchToken(credentials)
    const tokenV2 = await api.auth.fetchTokenV2(token)

    commit(UPDATE_TOKEN, token)
    commit(UPDATE_TOKEN_V2, tokenV2)

    localStorage.setItem(STORAGE_KEY_TOKEN, token)
    localStorage.setItem(STORAGE_KEY_TOKEN_V2, tokenV2)
  },

  /**
   * Clears the Tokens in the store.
   *
   * It removes the Tokens from the localStorage.
   */
  logout ({ commit }) {
    commit(UPDATE_TOKEN, null)
    commit(UPDATE_TOKEN_V2, null)

    localStorage.removeItem(STORAGE_KEY_TOKEN)
    localStorage.removeItem(STORAGE_KEY_TOKEN_V2)
  }
}

export default actions
